import { fetchAuthSession } from 'aws-amplify/auth';
import type { BeforeRequestHook } from 'ky';

import { withTimeout } from '@/shared/utils/promise';

export const TOKEN_ERROR = {
  status: 401,
  statusText: 'Missing authentication token',
} as const;

const AUTH_SESSION_TIMEOUT_MS = 10000;

const isTokenExpired = (exp: number | undefined): boolean => {
  if (!exp) return true;
  // exp is in seconds, Date.now() is in milliseconds
  return Date.now() >= exp * 1000;
};

export const authRequiredHeadersHook: BeforeRequestHook = async request => {
  let session = await withTimeout(fetchAuthSession(), AUTH_SESSION_TIMEOUT_MS)
    .catch(() =>
      withTimeout(
        fetchAuthSession({ forceRefresh: true }),
        AUTH_SESSION_TIMEOUT_MS,
      ),
    )
    .catch(() => undefined);

  // If token is expired, force refresh
  if (session && isTokenExpired(session.tokens?.accessToken?.payload?.exp)) {
    session = await withTimeout(
      fetchAuthSession({ forceRefresh: true }),
      AUTH_SESSION_TIMEOUT_MS,
    ).catch(() => undefined);
  }
  const token = session?.tokens?.accessToken?.toString();

  if (!token) {
    return new Response(null, TOKEN_ERROR);
  }

  request.headers.set('Authorization', `Bearer ${token}`);
};
